var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.84122 1.51792C7.45937 0.82736 8.54062 0.82736 9.15877 1.51792L9.70374 2.12664C10.0188 2.47858 10.4767 2.66826 10.9484 2.64218L11.7641 2.59709C12.6895 2.54592 13.454 3.31043 13.4029 4.23586L13.3578 5.05163C13.3317 5.52327 13.5214 5.9812 13.8733 6.29627L14.4821 6.84122C15.1726 7.45937 15.1726 8.54062 14.4821 9.15877L13.8733 9.70374C13.5214 10.0188 13.3317 10.4767 13.3578 10.9484L13.4029 11.7641C13.454 12.6895 12.6895 13.454 11.7641 13.4029L10.9484 13.3578C10.4767 13.3317 10.0188 13.5214 9.70374 13.8733L9.15877 14.4821C8.54062 15.1726 7.45937 15.1726 6.84122 14.4821L6.29627 13.8733C5.9812 13.5214 5.52327 13.3317 5.05163 13.3578L4.23586 13.4029C3.31043 13.454 2.54592 12.6895 2.59709 11.7641L2.64218 10.9484C2.66826 10.4767 2.47858 10.0188 2.12664 9.70374L1.51792 9.15877C0.82736 8.54062 0.82736 7.45937 1.51792 6.84122L2.12664 6.29627C2.47858 5.9812 2.66826 5.52327 2.64218 5.05163L2.59709 4.23586C2.54592 3.31043 3.31043 2.54592 4.23586 2.59709L5.05163 2.64218C5.52327 2.66826 5.9812 2.47858 6.29627 2.12664L6.84122 1.51792Z",
    stroke: "currentColor",
    strokeWidth: 1.45833
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06227 6.05469H6.05469V6.06227H6.06227V6.05469Z",
    stroke: "currentColor",
    strokeWidth: 2.1875,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95094 9.94531H9.94336V9.95289H9.95094V9.94531Z",
    stroke: "currentColor",
    strokeWidth: 2.1875,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3329 5.66406L5.66699 10.33",
    stroke: "currentColor",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountIcon);
export default __webpack_public_path__ + "static/media/discount-icon.ad18420610a70c66a77bc02d7530f6ad.svg";
export { ForwardRef as ReactComponent };